import type { SocketEventPayload } from '@makemydeal/dr-shared-bff-types';
import { DealXgTopic } from '@makemydeal/dr-shared-types/constants/dealXgTopics';

/**
 * Resolves the socket event's originating application name. On a `dealXgCreate` topic,
 * `data.changedBy` carries the previous version's (stale) application name, so the accurate
 * source is `data.dealStructure.versionCreatedBy`, falling back to `changedBy` if absent.
 * All other topics use `changedBy` as-is.
 */
const resolveApplicationName = (payload: SocketEventPayload | undefined): string => {
    if (!payload) return '';
    const changedByAppName = payload.data.changedBy?.applicationName;
    if (payload.topic === DealXgTopic.DEAL_XG_CREATE) {
        return payload.data.dealStructure?.versionCreatedBy?.applicationName ?? changedByAppName ?? '';
    }
    return changedByAppName ?? '';
};

/**
 * Returns true when the socket event's originating application name is present in the
 * provided whitelist. Comparison is case-insensitive. A missing payload/application name
 * or an empty whitelist yields false.
 */
export const isAppWhitelisted = (payload: SocketEventPayload | undefined, appNameWhitelist: string[] = []): boolean => {
    const applicationName = resolveApplicationName(payload).toLowerCase();
    return appNameWhitelist.map((name) => name.toLowerCase()).includes(applicationName);
};
